import { LeftOutlined, RightOutlined, SaveTwoTone } from '@ant-design/icons';
import Button from '@/shared/Button/Button';
import { StyledActionsFooter } from './StepActionsFooter.styled';

export default function StepActionsFooter({
  previous,
  previousAction,
  previousActionIcon,
  next,
  nextAction,
  nextHtmlType = 'button',
  cancel,
  cancelAction,
  finish,
  finishAction,
  finishHtmlType = 'button',
  save,
  saveAction,
  saveHtmlType = 'button',
  danger,
  disabled,
  allDisabled,
  processing,
  loading,
}) {
  return (
    <StyledActionsFooter>
      <div className="left-side">
        {previous && (
          <Button
            icon={
              previousActionIcon !== undefined ? (
                previousActionIcon
              ) : (
                <LeftOutlined />
              )
            }
            type="outlined"
            disabled={allDisabled || processing}
            onClick={previousAction}
            loading={processing}
          >
            {previous}
          </Button>
        )}
      </div>
      <div className="right-side">
        {cancel && (
          <Button
            type="outlined"
            disabled={allDisabled || processing}
            onClick={cancelAction}
            loading={processing}
          >
            {cancel}
          </Button>
        )}
        {next && (
          <Button
            icon={<RightOutlined />}
            type={finish ? 'outlined' : 'primary'}
            disabled={allDisabled || disabled || processing}
            onClick={nextAction}
            loading={processing || loading}
            htmlType={nextHtmlType}
          >
            {next}
          </Button>
        )}
        {save && (
          <Button
            type="primary"
            ghost
            icon={<SaveTwoTone />}
            disabled={allDisabled || disabled || processing}
            loading={processing || loading}
            onClick={saveAction}
            htmlType={saveHtmlType}
          >
            {save}
          </Button>
        )}
        {finish && (
          <Button
            type={danger ? 'danger' : 'primary'}
            disabled={allDisabled || disabled || processing}
            loading={processing || loading}
            onClick={finishAction}
            htmlType={finishHtmlType}
          >
            {finish}
          </Button>
        )}
      </div>
    </StyledActionsFooter>
  );
}
